'use strict';
import angular from 'angular';
import imageUploadHtmlUrl from './views/imageUpload.html';

var app = angular.module('app.imageUpload.component', []);
app.component('imageUploadWidget', {
    bindings: {
        showActions: '=',
        sets: '=',
    },
    templateUrl: imageUploadHtmlUrl,
    controller: function ($scope) {
        var self = this;
        self.file = null;
        self.base64String = '';

        self.onFileSelect = function (event) {
            self.file = event.target.files[0];
            if (self.file) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    $scope.$apply(function () {
                        self.base64String = e.target.result.split(',')[1];
                        self.updateSets();
                    });
                };
                reader.readAsDataURL(self.file);
            }
        };

        self.openFileDialog = function () {
            const fileInput = document.getElementById('file-upload');
            fileInput.click();

            fileInput.onchange = self.onFileSelect;
        };

        self.updateSets = function () {
            const jsonData = {
                fileName: self.file ? self.file.name : '',
                base64Data: self.base64String,
            };

            self.sets = jsonData;
        };

        self.initComponent = function () {
            if (self.sets && self.sets.length > 0) {
                self.sets = JSON.parse(self.sets);
            } else {
                self.sets = [{
                    fileName: null,
                    base64String: ''
                }];
            }
        };

        self.initComponent();
    }
});
